export const device = 'device';
